import PageShell from "@/components/PageShell";
import PublicSurveysSection from "@/components/home/PublicSurveysSection";
import JoinAndProjectSection from "@/components/home/JoinAndProjectSection";
import { ClipboardList } from "lucide-react";

export default function ConsultationsPage() {
  return (
    <PageShell>
      <section className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8 pt-10 sm:pt-14">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-plum-100 text-plum-700 mb-3 text-[12px] font-bold uppercase tracking-wider">
            <ClipboardList size={12} strokeWidth={2.5} /> Sondages &amp; consultations
          </div>
          <h1 className="heading-display text-[2rem] sm:text-[2.6rem] text-plum-900 leading-[1.1]">
            Votre avis fait Istres.
          </h1>
          <p className="mt-3 text-[16px] text-plum-700/75">
            Répondez aux sondages en cours, suggérez un projet, et gagnez des bons chez vos commerçants.
          </p>
        </div>
      </section>
      <PublicSurveysSection />
      <JoinAndProjectSection />
    </PageShell>
  );
}
